import { formateNumber } from 'shared/helpers';
export class AuthConverter {
  convertUserData(data) {
    const convertedData = {
      id: data.id,
      email: data.email,
      currency: data.currency,
      firstName: data.first_name,
      lastName: data.last_name,
      role: +data.role,
      isPartner: data.is_partner,
      typePartnerPayment: data.type_partner_payment,
      isWithdrawalAccess: data.is_withdrawal_access,
      isDepositAccess: data?.is_deposit_access ?? true,
      semiAutoWithdrawalEnabled: data?.semi_auto_withdrawal_enabled ?? false,
      username: data.username,
      arePromotionsAvailable: data.are_promotions_available,
      isPasswordChanged: data.changed_password,
      parentAgentId: data.parent_agent_id,
      canCreateOnlyPlayer: data.can_create_only_player,
      isHigherAgentsOperationsRestricted: data.is_higher_agents_operations_restricted ?? false,
      isPasswordDifficult: data.is_difficult_password,
    };
    return convertedData;
  }

  convertBalance(data) {
    const convertedData = {
      balance: formateNumber(data.balance),
      bonusBalance: +data.bonus_balance,
      currency: data.currency,
      isBanned: data.is_banned,
    };
    return convertedData;
  }

  convertMetadata(data) {
    const maxDeposit = data?.revshare_payment_settings?.max_deposit;

    return {
      maxDeposit: maxDeposit == null ? null : Number(maxDeposit),
    };
  }
}
